import { useContext, useEffect } from "react";
import "../../../styles/workspace_styles/UniversalComponentsStyles/BottomRightMessageBox.css";
import { AppContext } from "../../AppProvider";
const BottomRightMessageBox = () =>{
    const {
        showBottomRightMessageBox,setShowBottomRightMessageBox,
        setBottomRightMessageBoxMessage,bottomRightMessageBoxMessage
    } = useContext(AppContext);
    useEffect(() => {
        if(showBottomRightMessageBox){
            const timer = setTimeout(() =>{
                setBottomRightMessageBoxMessage("");
                setShowBottomRightMessageBox(false);
            },3000);
        }
    },[showBottomRightMessageBox]);
    if(!showBottomRightMessageBox) return null;
    return(
        <div className="bottom-right-message-box-container">
            <p>{bottomRightMessageBoxMessage}</p>
        </div>
    )
};
export default BottomRightMessageBox;